import { createBrowserRouter, Navigate } from "react-router";
import { ConsoleLayout } from "@/widgets/app-shell/ConsoleLayout";
import { RootErrorBoundary } from "@/widgets/app-shell/RootErrorBoundary";
import { NotFoundPage } from "@/pages/not-found/NotFoundPage";

export const router = createBrowserRouter([
  { path: "/", lazy: () => import("@/pages/home/route") },
  {
    path: "/app",
    element: <ConsoleLayout />,
    errorElement: <RootErrorBoundary />,
    children: [
      { index: true, element: <Navigate to="create/text-to-image" replace /> },
      {
        path: "create/text-to-image",
        lazy: () => import("@/pages/text-to-image/route"),
      },
      {
        path: "create/image-to-image",
        lazy: () => import("@/pages/image-to-image/route"),
      },
      {
        path: "create/text-to-video",
        lazy: () => import("@/pages/text-to-video/route"),
      },
      {
        path: "create/image-to-video",
        lazy: () => import("@/pages/image-to-video/route"),
      },
      {
        path: "create/video-generation",
        lazy: () => import("@/pages/video-generation/route"),
      },
      {
        path: "create/digital-human",
        lazy: () => import("@/pages/digital-human/route"),
      },
      { path: "assets", lazy: () => import("@/pages/assets/route") },
      { path: "history", lazy: () => import("@/pages/history/route") },
      { path: "tasks", lazy: () => import("@/pages/tasks/route") },
      { path: "models", lazy: () => import("@/pages/models/route") },
      {
        path: "models/:modelId",
        lazy: () => import("@/pages/models/detail-route"),
      },
      { path: "templates", lazy: () => import("@/pages/templates/route") },
      {
        path: "templates/:templateId",
        lazy: () => import("@/pages/templates/detail-route"),
      },
    ],
  },
  { path: "*", element: <NotFoundPage /> },
]);
